<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 300px; overflow-y: hidden;"
        v-model="valueHtml"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="handleCreated"
        @onChange="handleChange"
    />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor'
import axios from "axios";

export default {
  name: "commentEdit",
  components: {Editor, Toolbar},
  props: {
    defaultHtml: String
  },
  beforeDestroy() {
    const editor = this.editor;
    console.log(editor)
    if (editor == null) {
      return
    }
    editor.destroy()
  },
  beforeMount() {
    i18nChangeLanguage('en')
    this.valueHtml = this.defaultHtml
  },
  data() {
    return {
      mode: 'default',
      editor: null,
      valueHtml: "",
      toolbarConfig: {},
      editorConfig: {
        MENU_CONF: {
          uploadImage: {
            server: axios.defaults.baseURL + "file/imageUpload",
            fieldName: "file",
            // 单个文件的最大体积限制，默认为 2G
            maxFileSize: 2 * 1024 * 1024 * 1024,
            // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ['image/*'],
            withCredentials: true,
            timeout: 60 * 1000,
            customInsert(res, insertFn) {
              // res 即服务端的返回结果
              // 从 res 中找到 url alt href ，然后插图图片
              insertFn(res.data.url, "", "")
            },
          },
          uploadVideo: {
            // 上传视频的配置
            server: axios.defaults.baseURL + "file/videoUpload",
            fieldName: 'file',
            maxFileSize: 5 * 1024 * 1024 * 1024, // 5G
            allowedFileTypes: ['video/*'],
            withCredentials: true,
            timeout: 600 * 1000, // 15 秒
            customInsert(res, insertFn) {
              insertFn(res.data.url)
            },
          }
        }
      }
    }
  },
  methods: {
    handleCreated(editor) {
      this.editor = Object.seal(editor) // 记录 editor 实例，重要！
    },
    handleChange() {
      this.$emit("changeHtml", this.valueHtml)
    }
  },
  watch : {
    defaultHtml(newVal){
      console.log(newVal)
      this.valueHtml = newVal;
    }
  }
}
</script>

<style scoped>

</style>